function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.1667 18.8335H5.83333M36.1667 18.8335C38.5599 18.8335 40.5 20.7736 40.5 23.1668V36.1668C40.5 38.56 38.5599 40.5001 36.1667 40.5001H5.83333C3.4401 40.5001 1.5 38.56 1.5 36.1668V23.1668C1.5 20.7736 3.4401 18.8335 5.83333 18.8335M36.1667 18.8335V14.5001C36.1667 12.1069 34.2266 10.1668 31.8333 10.1668M5.83333 18.8335V14.5001C5.83333 12.1069 7.77343 10.1668 10.1667 10.1668M10.1667 10.1668V5.83346C10.1667 3.44022 12.1068 1.50012 14.5 1.50012H27.5C29.8932 1.50012 31.8333 3.44022 31.8333 5.83346V10.1668M10.1667 10.1668H31.8333",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/stack.699afe67.svg";
export { ForwardRef as ReactComponent };